<div #canvasContainer class="canvasContainer">
	<canvas #canvas></canvas>
</div>